import React from 'react';
import styled, { css } from 'styled-components';
import { Field } from 'react-final-form';

import { Chip as MuiChip } from '@mui/material';

const FormChipRadioButton = ({
  name,
  value,
  label,
  onChange,
  defaultValue,
  $centered = false,
  $softColor = false,
  dataId = 'form-chip-radio-button',
  readonly = false,
  $rounded = true,
  $isBig = false,
  type = 'radio',
  icon = null,
  $withDot = false,
  $dotColor = null,
  $fullWidth = false,
  outlined = false,
  $chipStyle = null,
  disabled = false,
  ...props
}) => {
  return (
    <Field
      defaultValue={defaultValue}
      name={name}
      value={value}
      component="input"
      type={type}
      readonly={readonly}
    >
      {({ input, meta }) => (
        <SMuiChip
          {...props}
          disabled={disabled}
          data-id={dataId}
          icon={icon}
          $isBig={$isBig}
          $centered={$centered}
          $softColor={$softColor}
          $fullWidth={$fullWidth}
          label={label}
          $withDot={$withDot}
          $dotColor={$dotColor}
          $rounded={$rounded}
          readonly={readonly}
          variant={
            input.checked || input.value === defaultValue
              ? 'default'
              : 'outlined'
          }
          $style={$chipStyle}
          onClick={(e) => {
            if (disabled) return;
            input.onChange(value);
            onChange(value);
          }}
        />
      )}
    </Field>
  );
};

const SMuiChip = styled(MuiChip)`
  && {
    font-weight: 600;
    font-size: ${({ $isBig }) => ($isBig ? '16px' : '14px')};
    line-height: ${({ $isBig }) => ($isBig ? '22px' : '19px')};
    width: ${({ $isBig, $fullWidth }) =>
      $fullWidth ? '100%' : $isBig ? '190px' : 'auto'};
    height: ${({ $isBig }) => ($isBig ? '40px' : 'auto')};
    color: ${({ $softColor, theme }) =>
      $softColor ? theme.palette.colors.black100 : theme.palette.colors.white};
    background: ${({ $softColor, theme }) =>
      $softColor ? theme.palette.colors.blue200 : theme.palette.colors.blue100};
    border-radius: ${({ $rounded }) => ($rounded ? '20px' : '5px')};
    padding: ${({ $fullWidth }) => ($fullWidth ? '8px 10px' : '8px 15px')};
    justify-content: ${({ $fullWidth, $centered }) =>
      $fullWidth ? ($centered ? 'center' : 'flex-start') : 'center'};

    .MuiChip-icon {
      color: ${({ theme }) => theme.palette.colors.white};
    }

    .MuiChip-label {
      display: ${({ label }) => (label ? 'flex' : 'none')};
    }

    &.MuiChip-outlined {
      color: ${({ theme }) => theme.palette.colors.black100};
      border-color: ${({ $rounded, theme }) =>
        $rounded ? theme.palette.colors.blue200 : theme.palette.colors.gray200};
      background: transparent;

      .MuiChip-icon {
        color: ${({ theme }) => theme.palette.colors.black100};
      }
    }
    &.MuiChip-clickableColorDefault:hover,
    &.MuiChip-clickableColorDefault:focus {
      color: ${({ $softColor, theme }) =>
        $softColor
          ? theme.palette.colors.black100
          : theme.palette.colors.white};
      background: ${({ $softColor, theme }) =>
        $softColor
          ? theme.palette.colors.blue200
          : theme.palette.colors.blue100};

      .MuiChip-icon {
        color: ${({ theme }) => theme.palette.colors.white};
      }
    }
  }

  && {
    ${({ $style }) => $style}
  }
  ${({ $withDot, $dotColor }) =>
    $withDot &&
    $dotColor &&
    css`
      && {
        background: ${$dotColor.sub};
        border: 1px solid ${$dotColor.main};
        color: ${({ theme }) => theme.palette.colors.black100};
        &.MuiChip-clickableColorDefault:hover,
        &.MuiChip-clickableColorDefault:focus {
          color: ${({ theme }) => theme.palette.colors.black100};
          background: ${$dotColor.sub};
          border-color: ${$dotColor.main};
        }
        .MuiChip-label {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          &:after {
            content: '';
            display: block;
            position: relative;
            width: 5px;
            height: 5px;
            border-radius: 100%;
            margin-left: 10px;
            background: ${$dotColor?.main};
          }
        }
      }
    `}
`;

export default FormChipRadioButton;
